import httpClient from '@/http-client'

export const store = data => {
    return httpClient
        .post('/api/event-management-registers', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default {
    store
}
